import symbolName from "@/util/symbol-name.mjs";

export const GAME_SYMBOL_TFT: unique symbol = symbolName("tft");
